export default "__VITE_ASSET__Duf88uRr__"